export const financeUrl = 'r/finance'